// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"78181384","553":"cbe01177","977":"f053072f"}[chunkId] + ".chunk.js";
};